import environment from '../.config/environment';

export const createLabRedirectUrl = (
    { contentId, langLocale = 'en-US' },
    globals = window
) => {
    const {
        HOST_NAME: { EVENT_HORIZON },
    } = environment(globals);
    const encodedContentId = encodeURIComponent(contentId);

    return `${EVENT_HORIZON}/sa/lab/${encodedContentId}?locale=${langLocale}`;
};

export const setWindowSearch = (str, globals = window) =>
    (globals.location.search = str);
